/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';

  
    const { basePath = '', loginPath = '' } = getHost("PRO_SETTLE", "542")
  

// 接口文档



export interface API75134Req {
  
  /** 会话标识Id */
  sessionToken?: string;
};



export type API75134Res = boolean;


// 接口函数 75134 删除session

export interface IUsePostAPI75134Return {
  /** 删除session: 接口请求状态 */
  isAPI75134Loading: boolean;
  /** 删除session: 接口请求返回数据 */
  dataAPI75134: API75134Res;
  /**  删除session: 接口数据请求方法 */
  fetchAPI75134Data: (inputs: API75134Req, config?: YWRequestConfig) => Promise<API75134Res>;
  /** 删除session: 接口请求URL */
  requestUrl: string;
}

export const usePostAPI75134 = ():IUsePostAPI75134Return => {
  let isMount = true;
  const [isAPI75134Loading, setIsAPI75134Loading] = useState(false);
  const [dataAPI75134, setDataAPI75134] = useState<API75134Res>({} as API75134Res);
  const requestUrl = `${basePath}/yoaichat-web/chat/session/delete`;

  const fetchAPI75134Data = async (inputs: API75134Req, config?: YWRequestConfig): Promise<API75134Res> => {
  
    
    const params = (reduceParams(inputs as unknown as R.Dictionary<API75134Req>) || {}) as API75134Req;
    
  
    if ( isMount ) {
      setIsAPI75134Loading(true);
    }

    try {
      
      
      
      const res: any = await Request.post<API75134Res>(`${basePath}/yoaichat-web/chat/session/delete`, params, {
        loginHost: loginPath,
        ...config
      });
      
      
      if (isMount) {
        setDataAPI75134(res || {} as API75134Res);
        setIsAPI75134Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI75134Loading(false);
      }
      return false as unknown as API75134Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI75134Loading,
    dataAPI75134,
    fetchAPI75134Data,
    requestUrl,
  }
}

